import Location from '@/domain/Location'

export default class MapStepDirections {
  constructor(data) {
    this.distance = data.distance
    this.duration = data.duration
    this.location = data.location
  }

  static mapFromGoogleResults(steps) {
    const stepsOfDirections = []

    for (const step of steps) {
      stepsOfDirections.push(
        new MapStepDirections({
          distance: step.distance.value,
          duration: step.duration.value,
          location: new Location({
            latitude: step.end_location.lat(),
            longitude: step.end_location.lng()
          })
        })
      )
    }

    return stepsOfDirections
  }
}
